/* globals rxSwitchboard, Class, jui, lp */
lp.editor.KeyController = Class.create( jui.EventSource, {
  initialize: function(editor, options) {
    /* jshint unused:vars */
    this.editor = editor;
    this.currentFocus = null;
    this.previousFocus = {obj: null, sendKeyEvents: false};
    this.sendKeyEvents = false;
    document.observe('keydown', this.onkeydown.bindAsEventListener(this));
    document.observe('keyup', this.onkeyup.bindAsEventListener(this));
    document.observe('keypress', this.onkeypress.bindAsEventListener(this));
    this.editor.addListener('pageLoaded', this);

    this._traceKeyboard = rxSwitchboard.getPublisher('keyboard_events');
  },

  pageLoaded: function(e) {
    e.data.addListener('beforePageSave', this);
  },

  beforePageSave: function() {
    var previous = this.currentFocus;
    this.requestFocus(null);
    this.requestFocus(previous);
  },

  requestFocus: function(obj, sendKeyEvents) {
    if (!obj || obj === this.currentFocus) {
      return; // already has focus
    }

    var currentBreakpoint        = this.editor.page.getCurrentBreakpoint();
    this.previousFocus           = {obj: this.currentFocus, sendKeyEvents: this.sendKeyEvents};
    this.currentFocus            = obj;
    this.currentFocus.breakpoint = currentBreakpoint;

    if (this.canBlurPreviousFocus()) {
      this.previousFocus.obj.blur();
    }

    this.sendKeyEvents = sendKeyEvents || false;

    this._traceKeyboard({
      type          : 'requestFocus',
      previousFocus : this.previousFocus,
      currentFocus  : this.currentFocus,
      sendKeyEvents : this.sendKeyEvents
    });

    return true;
  },

  clearFocus: function() {
    this.previousFocus = {obj: this.currentFocus, sendKeyEvents: this.sendKeyEvents};
    this.currentFocus  = null;

    if (this.canBlurPreviousFocus()) {
      this.previousFocus.obj.blur();
    }
  },

  canBlurPreviousFocus: function() {
    var currentBreakpoint = this.editor.page.getCurrentBreakpoint();
    var prevFocusObj      = this.previousFocus.obj;

    return prevFocusObj !== null &&
           prevFocusObj.breakpoint === currentBreakpoint &&
           prevFocusObj.blur;
  },

  removeFromFocus: function(obj){
    if (obj !== this.currentFocus) {
      return;
    }

    this.requestFocus(this.previousFocus.obj, this.previousFocus.sendKeyEvents);
  },

  onkeydown: function(event) {
    // jshint maxcomplexity: 18
    if (this.sendKeyEvents && this.currentFocus !== null && this.currentFocus.onkeydown) {
      this.currentFocus.onkeydown(event, this);
    }

    var keyPressed;

    if(window.event) {
      keyPressed = window.event.keyCode;
    } else {
      // FireFox
      keyPressed = event.which;
    }

    var modifierDown = event.ctrlKey || event.metaKey;

    // If the document activeElement is BODY the editor canvas is selected
    var documentBodyIsSelected = document.activeElement.tagName === 'BODY';

    if ( ! modifierDown) {
      return;
    }

    switch (keyPressed) {
      // Save
      case 83:
        this.editor.save();
        event.stop();
        break;

      // Copy
      case 67:
        if (documentBodyIsSelected) {
          this.editor.copyPasteManager.copyElementToClipboard();
        }
        break;

      // Paste
      case 86:
        if (documentBodyIsSelected) {
          this.editor.copyPasteManager.pasteElementFromClipboard();
        }
        break;

      // Undo/Redo
      case 90:
        if (documentBodyIsSelected) {
          if (event.shiftKey) {
            this.editor.redo();
          } else {
            this.editor.undo();
          }
          event.stop();
        }
        break;

      // Send forward
      case 219:
        if (documentBodyIsSelected && event.altKey) {
          event.preventDefault();
          this.editor.changeZIndex(-1);
        }
        break;

      // Send backward
      case 221:
        if (documentBodyIsSelected && event.altKey) {
          event.preventDefault();
          this.editor.changeZIndex(1);
        }
        break;
    }
  },

  onkeyup: function(e) {
    if (this.sendKeyEvents && this.currentFocus !== null && this.currentFocus.onkeyup) {
      this.currentFocus.onkeyup(e,this);
    }
  },

  onkeypress: function(e) {
    if (this.sendKeyEvents && this.currentFocus !== null && this.currentFocus.onkeypress) {
      this.currentFocus.onkeypress(e,this);
    }
  }

});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/key_controller.js
// module id = 1010
// module chunks = 0